import React, { useContext } from 'react';
import PropTypes from 'prop-types';
// components
import Mockexam from './../../components/Mockexam/Mockexam';
import { DashContext, CommonContext } from './../../contexts/constant/ActionTypes';

const MockexamPage = ({history, match, loginDetails}) => {
    const dashContext = useContext(DashContext);
    const commonContext = useContext(CommonContext);

	return (
        <Mockexam 
            history={history} 
            match={match} 
            loginDetails={loginDetails}
            dashContext={dashContext}
            commonContext={commonContext}
        />
	);
}

MockexamPage.propTypes = {
    history: PropTypes.instanceOf(Object),
    match: PropTypes.instanceOf(Object)
};

MockexamPage.defaultProps = {
    history: {},
    match: {}
};

export default MockexamPage;



// WEBPACK FOOTER //
// ./containers/MockexamPage/MockexamPage.js